<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'TicketHistory',
  }
</script>

<style scoped>
</style>